<ion-card style="padding: 0;">
  <div class="overcard-title">
      {{title}}
  </div>
  <ion-col size="1" *ngIf="page > 0" class="goals-text">
    <ion-button (click)="previousPage(this.page)" style="width: 100%;color: #000;position: absolute;
  bottom: -1px; --background: transparent"><</ion-button>
  </ion-col>

  <ion-row>

    <ion-col size="12"  *ngIf="page == 0" class="goals-text">
      <div class="overcard-title">
        {{desc}}
      </div>
      
      <ion-button (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Klik hier</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 1" class="goals-text">
         <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
         <hr>
        <ion-item>
          <ion-label>Bugerlijke staat</ion-label>
          <ion-select placeholder="Selecteer" [(ngModel)]="maritalStatus">
            <ion-select-option value="1">Alleen</ion-select-option>
            <ion-select-option value="2">Gehuwd</ion-select-option>
            <ion-select-option value="3">Samenwonend</ion-select-option>
          </ion-select>
        </ion-item>

        <ion-list>
          <ion-radio-group [(ngModel)]="marriedBefore">
            <ion-list-header>
              <ion-label>Ben je getrouwd geweest?</ion-label>
            </ion-list-header>
        
            <ion-item>
              <ion-label>Ja</ion-label>
              <ion-radio slot="start" value="true"></ion-radio>
            </ion-item>
        
            <ion-item>
              <ion-label>Nee</ion-label>
              <ion-radio slot="start" value="false"></ion-radio>
            </ion-item>
          </ion-radio-group>
        </ion-list>


        <ion-button [disabled]="maritalStatus == 0" (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;">Volgende stap</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 2" class="goals-text">
      <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Bruto jaarsalaris: </ion-label>
          <ion-label>€</ion-label>
          <ion-input value="0" type="number" step="0.01" [(ngModel)]="salary"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Zonder extra's en onkostenvergoedingen, zoals reis- en representatiekostenvergoedingen en vergoedingen voor een ziektekostenverzekering.
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>13e Maand </ion-label>
          <ion-checkbox [(ngModel)]="thirteenthMonth"></ion-checkbox>
        </ion-item>
        <ion-note slot="end">
          Indien deze onvoorwaardelijk is.
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>Vakantiegeld </ion-label>
          <ion-checkbox [(ngModel)]="holidayPay"></ion-checkbox>
        </ion-item>
        <ion-note slot="end">
          In de regel is dit 8%.
        </ion-note>
      </ion-list>
      <br>

      <ion-button [disabled]="salary == 0" (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Volgende stap</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 3" class="goals-text">
      <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Ontvangen partneralimentatie: </ion-label>
          <ion-label>€</ion-label>
          <ion-input value="0" step="1" type="number" [(ngModel)]="partnerAlimonyReceive"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Het gaat hier alleen om de partneralimentatie die u per jaar ontvangt, zonder eventuele kinderalimentatie.
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>Zelf te betalen partneralimentatie: </ion-label>
          <ion-label>€</ion-label>
          <ion-input value="0" step="1" type="number" [(ngModel)]="partnerAlimony"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Indien van toepassing: hoeveel partneralimentatie betaalt u zelf per jaar? Het gaat hier alleen om partneralimentatie, zonder eventuele kinderalimentatie.
        </ion-note>
      </ion-list>
      <br>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Volgende stap</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 4" class="goals-text">
      <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Consumptief krediet: </ion-label>
          <ion-label>€</ion-label>
          <ion-input value="0" type="number" [(ngModel)]="personalLoan"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Als u een consumptief krediet (persoonlijke lening, doorlopend krediet, creditcardkrediet of krediet op uw betaalrekening) heeft, wat is dan de hoogte hiervan? Tel indien van toepassing de verschillende kredieten bij elkaar op. Voor een creditcard of doorlopend krediet gaat het om de opnamelimiet. Bij een persoonlijke lening om de hoogte van de oorspronkelijke lening. Tip: het is vaak verstandig om al het consumptief krediet af te lossen voordat u een hypotheek gaat afsluiten, omdat deze de maximaal mogelijke hypotheek verlagen.
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>Studieschuld: </ion-label>
          <ion-label>€</ion-label>
          <ion-input value="0" type="number" [(ngModel)]="studentDebt"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Als u een studieschuld heeft, wat is dan de hoogte van de oorspronkelijke studieschuld?
        </ion-note>
        <ion-item *ngIf="studentDebt > 0">
          <ion-label>Type studieschuld</ion-label>
          <ion-select placeholder="Selecteer" [(ngModel)]="studentDebtType" (ionChange)="studentDebtTypeCheck()">
            <ion-select-option value="old">oude stelsel</ion-select-option>
            <ion-select-option value="new">nieuwe stelsel</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-note slot="end" *ngIf="studentDebt > 0">
          Om wat voor lening gaat het: oude leenstelsel (voor 1-sep-2015) of volgens het nieuwe leenstelsel (vanaf 1-sep-2015).
        </ion-note>
      </ion-list>
      <br>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Volgende stap</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 5" class="goals-text">
      <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Marktwaarde van de woning: </ion-label>
        </ion-item>
        <ion-item>
          <ion-label>€</ion-label>
          <ion-input value="0" type="number" [(ngModel)]="marketValue"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Dit is de koopprijs, de laatste WOZ-waarde of de getaxeerde waarde (na eventuele verbouwing). NB Ook de marktwaarde van de woning kan invloed hebben op de maximale hypotheek die mogelijk is. Als u de marktwaarde (nog) niet weet, vul dan niets in. De maximale hypotheek wordt dan berekend alleen op basis van uw inkomen(s).
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>Looptijd hypotheek: </ion-label>
          <ion-input value="0" step="1" type="number" [(ngModel)]="duration" (ionChange)="durationChecker()"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Normaal wordt de maximale hypotheek berekend uitgaande van een looptijd van 30 jaar. In bijzondere gevallen kan een kortere looptijd van toepassing zijn. Een kortere looptijd geeft een lagere hypotheek. Als u geen looptijd invult, wordt er gerekend met een looptijd van 30 jaar.
        </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label>Hypotheekrente: </ion-label>
          <ion-input value="0" step="1" type="number" [(ngModel)]="interest" (ionChange)="fetchCostOfLiving()" [disabled]="duration < 10"></ion-input>
          <ion-label>%</ion-label>
        </ion-item>
        <ion-note slot="end">
          Bij een rentevastperiode kleiner dan 10 jaar moet u niets invullen. Er moet dan gerekend worden met de door de AFM vastgelegde toetsrente van 5%, dit is wettelijk zo bepaald. Als de rente wordt vastgezet voor de gehele looptijd van de hypotheek, mag er altijd met de werkelijke rente gerekend worden. Ook als de rentevastperiode korter is dan 10 jaar. Vul in dat geval hier ook de hypotheekrente in die u gaat betalen. Huidige gemiddelde Startershypotheek, op basis van 100% financiering, annuitair voor 20 jaar vast = 1,7%
        </ion-note>
      </ion-list>
      <br>

      <ion-button [disabled]="marketValue == 0" (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Volgende stap</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 6" class="goals-text">
      <h2 class="goals-text-stap">Stap {{page}}/{{maxPage}}</h2>
      <hr>
      <ion-list>
        <ion-item>
          <ion-label>Energiezuinige woning</ion-label>
          <ion-select placeholder="Selecteer" value="no" [(ngModel)]="energyEfficientHome">
            <ion-select-option value="0">Nee</ion-select-option>
            <ion-select-option value="energyLabel">(A++) energielabel</ion-select-option>
            <ion-select-option value="zeroEnergy">NulopdeMeter-woning</ion-select-option>
            <ion-select-option value="zeroEnergyGuarantee">NulopdeMeter met EP-garantie</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-note slot="end">
          Voor energiezuinige woningen is, bij een inkomen vanaf € 33.000, een hogere hypotheek toegestaan. Kies:

    Nee – in alle andere situaties.>
    (A++) energielabel – als de woning een energielabel van tenminste (A++) heeft.
    NulopdeMeter-woning – als het gaat om een woning met een energie-index of een energieprestatie-coëfficiënt gelijk aan of lager dan nul.
    NulopdeMeter met EP-garantie – als voor de NulopdeMeter-woning een energieprestatiegarantie is afgegeven voor een periode van ten minste tien jaar.
        </ion-note>
      </ion-list>
      <ion-list>
        <ion-item>
          <ion-label>Energiebesparende voorzieningen (EBV): </ion-label>
        </ion-item>
        <ion-item>
          <ion-label>€</ion-label>
          <ion-input value="0" type="number" [(ngModel)]="energySavingFacilities"></ion-input>
        </ion-item>
        <ion-note slot="end">
          Als er energiebesparende voorzieningen worden aangeschaft, zoals isolatie, zonnepanelen, etc., welk bedrag wordt dan hieraan besteed? Energiebesparende voorzieningen mogen worden meegefinancierd in de hypotheek tot maximaal 106% van de waarde van de woning. Let op: de marktwaarde van de woning moet ook opgegeven worden om de EBV mee te kunnen nemen in de berekening.  
        </ion-note>
      </ion-list>
      <br>

      <ion-button (click)="nextpage(this.page)" style="width: 100%;padding-left: 20px;
      padding-right: 20px;
      margin-bottom: 20px;">Resultaat tonen</ion-button>
    </ion-col>

    <ion-col  *ngIf="page == 7" class="goals-text">
      <h2 class="goals-text-stap">Resultaat</h2>
      <hr>
      <ion-list>
        <ion-item *ngIf="income() > 0">
          <ion-label>inkomen</ion-label>
        </ion-item>
          <ion-label *ngIf="salary">Bruto jaarsalaris: </ion-label>
          <ion-note slot="end" *ngIf="salary">
            {{formatNumber(salary)}}
          </ion-note>
          <br *ngIf="salary">
          <ion-label *ngIf="thirteenthMonthAmount()">13e maand: </ion-label>
          <ion-note slot="end" *ngIf="thirteenthMonthAmount()">
            {{formatNumber(thirteenthMonthAmount())}}
          </ion-note>
          <br *ngIf="thirteenthMonthAmount()">
          <ion-label *ngIf="holidayAmount()">Vakantiegeld: </ion-label>
          <ion-note slot="end" *ngIf="holidayAmount()">
            {{formatNumber(holidayAmount())}}
          </ion-note>
          <br *ngIf="holidayAmount()">
          <ion-label *ngIf="partnerAlimonyReceive">Partneralimentatie: </ion-label>
          <ion-note slot="end" *ngIf="partnerAlimonyReceive">
            {{formatNumber(partnerAlimonyReceive)}}
          </ion-note>
        <ion-item>
          <ion-label>Totaal inkomen: </ion-label>
          <ion-note slot="end">
            {{formatNumber(income())}}
          </ion-note>
        </ion-item>
      </ion-list>
      <br>
      <ion-list>
        <ion-item *ngIf="income() > 0">
          <ion-label>Gegevens woning</ion-label>
        </ion-item>
        <ion-label *ngIf="partnerAlimony">Partneralimentatie: </ion-label>
        <ion-note *ngIf="partnerAlimony">
          {{formatNumber(partnerAlimony)}}
        </ion-note>
        <br *ngIf="partnerAlimony">
        <ion-label *ngIf="personalLoan">Consumptief krediet ({{personalLoanPercentage}}%): </ion-label>
        <ion-note *ngIf="personalLoan">
          {{formatNumber(personalLoanAmount())}}
        </ion-note>
        <br *ngIf="personalLoan">
        <ion-label *ngIf="studentDebt">Studieschuld ({{studentDebtType}}) - ({{studentDebtPercentage}}%): </ion-label>
        <ion-note *ngIf="studentDebt">
          {{formatNumber(studentDebtAmount())}}
        </ion-note>
        <ion-item *ngIf="expenses() > 0">
          <ion-label>Uitgaven: </ion-label>
          <ion-note slot="end">
            {{formatNumber(expenses())}}
          </ion-note>
        </ion-item>
      </ion-list>
      <br>
      <ion-list>
        <ion-item *ngIf="income() > 0">
          <ion-label>Overige </ion-label>
        </ion-item>
          <ion-label *ngIf="marketValue">Marktwaarde: </ion-label>
          <ion-note slot="end" *ngIf="marketValue">
            {{formatNumber(marketValue)}}
          </ion-note>
          <br>
          <ion-label *ngIf="energyBenefit()">Extra bedrag energie: </ion-label>
          <ion-note slot="end" *ngIf="energyBenefit()">
            {{formatNumber(energyBenefit())}}
          </ion-note>
      </ion-list>
      <br>
      <ion-list>
        <ion-item>
          <ion-label *ngIf="income() > 0">Besteedbaar inkomen</ion-label>
        </ion-item>
          <ion-label>Bruto inkomen: </ion-label>
          <ion-note slot="end">
            {{formatNumber(grossIncome())}}
          </ion-note>
          <br>
          <ion-label>Max hypotheeklast (maand): </ion-label>
          <ion-note slot="end">
            {{formatNumber(maxLivingCostPerMonth())}}
          </ion-note>
          <br>
          <ion-label>Maximale hypotheek inkomen: </ion-label>
          <ion-note slot="end">
            {{formatNumber(maxMortgageIncome())}}
          </ion-note>
        <ion-item>
          <ion-label>Maximale hypotheek: </ion-label>
          <ion-note slot="end">
            {{formatNumber(maxMortgage())}}
          </ion-note>
        </ion-item>
      </ion-list>
      <br>
      <ion-item>
        <ion-note *ngIf="maxMortgage() >= marketValue" slot="end">
          Op basis van de door jou ingevulde gegevens kun jij deze woning kopen. Wil jij direct starten met een aanvraag. klik dan op aanvragen.
        </ion-note>
        <ion-note *ngIf="maxMortgage() < marketValue" slot="end">
          Op basis van de gegevens die jij hebt ingevuld lijkt het erop dat je deze woning niet kunt kopen. Neem contact met ons op, om jouw situatie te bespreken
        </ion-note>
      </ion-item>

      <ion-button (click)="goToFinopsSite()" style="width: 100%;padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;">Aanvragen</ion-button>
      <br>
      <ion-button (click)="this.page = 0" style="width: 100%;padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;">Bereken opnieuw</ion-button>
    </ion-col>

  </ion-row>

</ion-card>
